// ** React Imports
import { memo } from 'react'

// ** MUI Imports
import { Close } from '@mui/icons-material'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  styled
} from '@mui/material'

// **Utils Imports
import { closeWithConfirmation as handleConfirmationClose } from '../../utils/utils'

export const CustomCloseButton = styled(IconButton)(({ theme }) => ({
  top: 0,
  right: 0,
  color: 'grey.500',
  position: 'absolute',
  boxShadow: theme.shadows[2],
  transform: 'translate(10px, -10px)',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: `${theme.palette.background.paper} !important`,
  transition: 'transform 0.25s ease-in-out, box-shadow 0.25s ease-in-out',
  '&:hover': {
    transform: 'translate(7px, -5px)'
  }
}))

const CustomDialog = ({
  open,
  title = null,
  children,
  handleClose,
  dialogPaperStyle = {},
  outsideClikClose = true,
  renderHeader = null,
  className = '',
  closeWithConfirmation = false,
  disableEnforceFocus = false
}) => {
  return (
    <Dialog
      fullWidth
      disableEnforceFocus={disableEnforceFocus}
      className={className || 'custom-dialog'}
      open={open}
      {...(outsideClikClose
        ? {
            onClose: (e) => {
              e?.stopPropagation()
              if (closeWithConfirmation) {
                handleConfirmationClose(handleClose)
              } else {
                handleClose()
              }
            }
          }
        : {})}
      aria-labelledby="customized-dialog-title"
      sx={{
        '& .MuiDialog-paper': { overflow: 'visible', ...dialogPaperStyle }
      }}
    >
      {(title || renderHeader) && (
        <DialogTitle
          id="customized-dialog-title"
          sx={{
            p: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {title && (
            <Typography variant="h5" fontSize={'22px'} component="span">
              {title}
            </Typography>
          )}

          <Box sx={{ marginRight: '20px' }}>
            {renderHeader && renderHeader()}
          </Box>
          {handleClose && (
            <CustomCloseButton
              aria-label="close"
              onClick={(e) => {
                e?.stopPropagation()
                if (closeWithConfirmation) {
                  handleConfirmationClose(handleClose)
                } else {
                  handleClose()
                }
              }}
            >
              <Close />
            </CustomCloseButton>
          )}
        </DialogTitle>
      )}
      <DialogContent
        dividers
        sx={{ p: (theme) => `${theme.spacing(4)} !important` }}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}

export default memo(CustomDialog)
